export default __webpack_public_path__ + "src/assets/ethereum.5165ba3d47359f8df913de6b6f9bec6e.svg";